import Vue from 'vue'
import Router from 'vue-router'
import pc_routes from './routes_pc'
import m_routes from './routes_m'

/********* 移动端框架引用 **********/
import { Icon } from 'vant'
import { Button } from 'vant'
import { Tabbar, TabbarItem } from 'vant'
import { Search } from 'vant'
import { Swipe, SwipeItem } from 'vant'
import { Lazyload } from 'vant'
import { Cell, CellGroup } from 'vant'
import { NavBar } from 'vant'
import { List } from 'vant'
import { TreeSelect } from 'vant'
import { Field } from 'vant'
import { Loading } from 'vant'
import { Popup  } from 'vant'
import { Dialog } from 'vant'
import { Uploader } from 'vant'
import { Actionsheet } from 'vant'

Vue.use(Field)
Vue.use(TreeSelect)
Vue.use(List)
Vue.use(NavBar)
Vue.use(Cell).use(CellGroup)
Vue.use(Lazyload)
Vue.use(Swipe).use(SwipeItem)
Vue.use(Search)
Vue.use(Tabbar).use(TabbarItem)
Vue.use(Button)
Vue.use(Icon)
Vue.use(Loading)
Vue.use(Popup)
Vue.use(Dialog)
Vue.use(Uploader)
Vue.use(Actionsheet)
/********* 移动端框架引用 - 结束 **********/

Vue.use(Router)
const _router = new Router({
    mode: 'history',
    base: BASE_URL,
    routes: [
        //admin和m都是二级目录，要放在pc的前面
        ...m_routes,
        ...pc_routes,
    ],
    // 记录滚动位置
    scrollBehavior(to, from, savePosition) {
        if (savePosition) {
            return savePosition
        } else {
            return { y: 0}
        }
    }
})

function browserRedirect() {
    var isPhone = false;
    var sUserAgent = navigator.userAgent.toLowerCase();
    var bIsIpad = sUserAgent.match(/ipad/i) == "ipad";
    var bIsIphoneOs = sUserAgent.match(/iphone os/i) == "iphone os";
    var bIsMidp = sUserAgent.match(/midp/i) == "midp";
    var bIsUc7 = sUserAgent.match(/rv:1.2.3.4/i) == "rv:1.2.3.4";
    var bIsUc = sUserAgent.match(/ucweb/i) == "ucweb";
    var bIsAndroid = sUserAgent.match(/android/i) == "android";
    var bIsCE = sUserAgent.match(/windows ce/i) == "windows ce";
    var bIsWM = sUserAgent.match(/windows mobile/i) == "windows mobile";
    if (bIsIpad || bIsIphoneOs || bIsMidp || bIsUc7 || bIsUc || bIsAndroid || bIsCE || bIsWM) {
        isPhone = true;
    }
    return isPhone;
}

_router.beforeEach((to, from, next) => {
    let token = localStorage.getItem('as_user_token')
    let adminToken = localStorage.getItem('as_admin_token')
    //console.log('beforeEach_token:'+token);
    console.log(to.path)
    if (!to.path || to.path == "/") {
        if (browserRedirect()) {
            next({ path: "/m" });
        } else {
            next();
        }
    } else {
        next();
    }
    //判断会员是否需要登录
    if (to.meta) {
        if (to.meta.auth && !token) { //前端：需要登录但未登录
            let login="/login";
            if(to.path.indexOf('/m/')>=0){
                login='/m/login';
            }
            next({
                path: login,
                query: { returnUrl: to.path },
                replace: true
            })
        } else {
            next()
        }
        if(to.meta.title){
            document.title=to.meta.title+' - 澳尚健康';
        }
    } else {
        next()
    }
})

_router.afterEach((to, from, next) => {
    // window.scrollTo(0,0);
})

export default _router
